module.exports = __webpack_public_path__ + "img/logo-VTC.7bc6d462.png";